// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"accesstype-integration_checkboxWrapper__21s5E","hintWrapper":"accesstype-integration_hintWrapper__1m-ZD","docWrapper":"accesstype-integration_docWrapper__14Djr"};